import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=196fdee8&scoped=true&"
import script from "./Save.vue?vue&type=script&lang=js&"
export * from "./Save.vue?vue&type=script&lang=js&"
import style0 from "./Save.vue?vue&type=style&index=0&id=196fdee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fdee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196fdee8')) {
      api.createRecord('196fdee8', component.options)
    } else {
      api.reload('196fdee8', component.options)
    }
    module.hot.accept("./Save.vue?vue&type=template&id=196fdee8&scoped=true&", function () {
      api.rerender('196fdee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/Save.vue"
export default component.exports